import { useRef } from "react";
import documentIcon from "../../_assets/vectors/document-icon.svg";

export function UploadFile({
  previewPictureUrl = null,
  file,
  children = null,
  setFile,
  placeholderLabel = "Upload File",
  emptyPreviewClass = "py-8",
  showDeleteButton = true,
}) {
  const fileRef = useRef();

  return (
    <div className="UploadFile rounded cursor-pointer hover:shadow">
      <input
        className="hidden"
        type="file"
        ref={fileRef}
        onChange={(e) => {
          setFile(e.target.files[0]);
        }}
      />
      {file || previewPictureUrl ? (
        <PreviewSelected
          file={file}
          previewPictureUrl={previewPictureUrl}
          onClick={(e) => {
            fileRef.current.click();
          }}
          onDelete={() => {
            setFile(null);
          }}
          showDeleteButton={showDeleteButton}
          emptyPreviewClass={emptyPreviewClass}
        />
      ) : (
        <div
          className={`empty-preview px-3 ${emptyPreviewClass} my-2`}
          onClick={(e) => {
            fileRef.current.click();
          }}>
          {children ? (
            children
          ) : (
            <PreviewChild placeholderLabel={placeholderLabel} />
          )}
        </div>
      )}
    </div>
  );
}

function PreviewChild({ placeholderLabel = "Upload File" }) {
  return (
    <div className="flex flex-col items-center">
      <img src={documentIcon} width="18px" alt="" />
      <span className="mt-1 text-xs text-gray-400">{placeholderLabel}</span>
    </div>
  );
}

function PreviewSelected({
  file,
  previewPictureUrl,
  onClick,
  onDelete,
  emptyPreviewClass = "py-8",
  showDeleteButton = true,
}) {
  // if preview picture
  if (previewPictureUrl && !file) {
    return (
      <div
        onClick={onClick}
        className="PreviewSelected flex items-center justify-center">
        {showDeleteButton && (
          <div
            className="delete"
            onClick={(e) => {
              e.preventDefault();
              onDelete();
            }}>
            &times;
          </div>
        )}
        <img
          className="my-2 border theme-border-default rounded"
          src={previewPictureUrl}
          alt={""}
          title={""}
        />
      </div>
    );
  }

  // if image
  if (file.type && file.type.startsWith("image")) {
    return (
      <div className="PreviewSelected">
        {showDeleteButton && (
          <div
            className="delete"
            onClick={(e) => {
              e.preventDefault();
              onDelete();
            }}>
            &times;
          </div>
        )}
        <img
          className="my-2  border theme-border-default rounded"
          src={URL.createObjectURL(file)}
          alt={file.name}
          title={file.name}
        />
      </div>
    );
  }

  // else
  return (
    <div className={`empty-preview px-3 ${emptyPreviewClass} my-2`}>
      <div className="flex flex-col items-center">
        <img src={documentIcon} width="18px" alt="" />
        <span className="mt-1 text-xs text-gray-400">{file.name}</span>
      </div>
    </div>
  );
}
